interface BaseSubmitData {
    jobDescription?: string;
    postcode?: string;
    isNationalLead?: string;
    buyerName?: string;
    buyerEmail?: string;
    phoneNumber?: string;
    qaList?: any;
    formType: string;
    sellerSource: string;
    requestId: string;
    buyerId: string;
    sourceURL: string;
    gtCateId: string;
    sellerSkillId: any;
    sellerSkill: any;
}

const processDescribeFormDataToQaList = (describeFormData: Record<string, string | string[] | undefined>) => {
    const result: { [key: string]: string[] } = {};

    Object.entries(describeFormData).forEach(([key, value]) => {
        const ignoredKeys = ['postcode', 'remote', 'jobDescription'];
        if (ignoredKeys.includes(key) || key.endsWith('-other')) return;
        const baseKey = key.split('-')[0];
        const processed = Array.isArray(value) ? value : [value ?? ''];
        result[baseKey] = processed;
    });

    Object.entries(describeFormData).forEach(([key, value]) => {
        if (!key.endsWith('-other')) return;
        const baseKey = key.split('-')[0];
        const arr = result[baseKey];
        if (!arr || arr.length === 0) return;

        const otherText = Array.isArray(value) ? (value[0] ?? '') : (value ?? '');
        if (!otherText) return;

        const lastIdx = arr.length - 1;
        const current = arr[lastIdx] || '';
        const dashIdx = current.indexOf('-');
        const pure = dashIdx >= 0 ? current.slice(0, dashIdx) : current;

        arr[lastIdx] = `${pure}-${otherText}`;
    });

    return result;
};

export const buildBaseSubmitData = (
    describeFormData: any,
    contactFormData: any,
    requestId: string,
    userId: string,
    currentPageUrl: string,
    categoryId: string,
    selectedService: any,
    formType: string
): BaseSubmitData => {
    return {
        jobDescription: describeFormData.jobDescription,
        postcode: describeFormData.postcode,
        isNationalLead: describeFormData.remote || 'none',
        buyerName: contactFormData.buyerName,
        buyerEmail: contactFormData.buyerEmail,
        phoneNumber: contactFormData.phoneNumber,
        qaList: processDescribeFormDataToQaList(describeFormData),
        formType,
        sellerSource: 'Bark',
        requestId,
        buyerId: userId,
        sourceURL: currentPageUrl,
        gtCateId: categoryId,
        sellerSkillId: selectedService?.id || selectedService?.value || null,
        sellerSkill: selectedService?.displayName || null
    };
};

export const filterDescribeFormDataByQaList = (
    describeFormData: Record<string, string | string[] | undefined>,
    qaList: Array<{ questionId: string }>
) => {
    const safeQaList = Array.isArray(qaList) ? qaList : [];
    const allowedQuestionIds = new Set(safeQaList.map(item => item.questionId));
    const alwaysKeep = new Set(['postcode', 'remote', 'jobDescription']);
    const next: { [key: string]: string | string[] | undefined } = {};

    Object.keys(describeFormData || {}).forEach(key => {
        if (alwaysKeep.has(key)) {
            next[key] = describeFormData[key];
            return;
        }
        if (allowedQuestionIds.has(key)) {
            next[key] = describeFormData[key];
            return;
        }
        if (key.endsWith('-other')) {
            const baseId = key.slice(0, -'-other'.length);
            if (allowedQuestionIds.has(baseId)) {
                next[key] = describeFormData[key];
            }
        }
    });

    return next;
};
